import {React, useState} from 'react'
import useUser from '../../hooks/useUser';
import useWorkOrder from '../../hooks/useWorkOrder'
import { LinearProgress } from '@mui/material';

//table
import { styled, ThemeProvider, createTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";



import axios from 'axios';
import useLocation from '../../hooks/useLocation';
import WriteLog from '../Globals/WriteLog';


//icons
import{    
    ArrowDownTrayIcon,
    EyeIcon,    
}from "@heroicons/react/24/outline"


function WorkOrder({addrSeq}) {
    const { user } = useUser()    
    WriteLog("WorkOrder->user", user)
    WriteLog("WorkOrder->addrSeq", addrSeq)    
    const { workorders } = useWorkOrder(user?.customer_code, addrSeq, user?.token);      
    //window.location.reload(false);
    WriteLog("WorkOrder->workorders", workorders)



    //loading
    const [preViewLoading, setPreViewLoading] = useState(false)    
    //location
    const { locations } = useLocation(user?.customer_code, user?.token);                
    console.log("WorkOrder->locations", locations);      
    var location = locations?.locations?.filter(l=> l.AddrSeq == addrSeq);
    if(location?.length>0) location = location[0];
    console.log("WorkOrder->location", location);
    
    //Theme    
    const theme = createTheme({
        status: {
            danger: '#e53e3e',
        },
        palette: {
            primary: {
            main: '#02046E',
            darker: '#053e85',
            },
            neutral: {
            main: '#64748B',
            contrastText: '#fff',
            },
        },
        });        
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "#DDD",
          color: theme.palette.common.black,   
          height:60       
        },
        [`&.${tableCellClasses.body}`]: {          
          border:'3px solid #FFF',           
          height:50,
          padding:0,          
          margin:0  
        },
        [`&.${tableCellClasses.root}`]: {            
            border:'3px solid #FFF',            
          },        
          [`&.${tableCellClasses.hover}`]: {            
            backgroundColor: "#0F0",
          },        
      }));
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,   
                     
        },               
    })); 
    function convertUTCDateToLocalDate(date) {
        var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);    
        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();    
        newDate.setHours(hours - offset);    
        return newDate;   
    }
    
    function base64ToArrayBuffer (base64) {
        const binaryString = window.atob(base64); // Comment this if not using base64
        const bytes = new Uint8Array(binaryString.length);
        return bytes.map((byte, i) => binaryString.charCodeAt(i));
        }           

    const saveFile = async (blob) => {
        const a = document.createElement('a');
        a.download = 'my-file.pdf';
        a.href = URL.createObjectURL(blob);  
        a.addEventListener('click', (e) => {
            setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
          }); 
        a.click()
        console.log("File Saved");     
      };
    
    const PreviewReport = async (e, WoId) =>{    
        e.preventDefault();
        console.log("WorkOrder->WoId", WoId);
        console.log("WorkOrder->token", user?.token );
        setPreViewLoading(true)
        await axios.get(process.env.REACT_APP_SERVER_BASE_URL +'/work_order/report/preview?id='+WoId,    
            {                
                headers: {                
                    'Authorization':user?.token,                    
                },
            }
            ).then(function (res){
                    setPreViewLoading(false)
                    console.log("PreviewReport->data", res.data);                      
                    var file = new Blob([base64ToArrayBuffer(res.data)], { type: 'application/pdf' });                    
                    var fileURL = URL.createObjectURL(file);                    
                    window.open(fileURL);                                       
                   
                }).catch(function(error){
                    setPreViewLoading(false)
                    console.log("PreviewReport->Error->", error);
                });            
    }
    const DownloadReport = async (e, WoId) =>{    
        e.preventDefault();
        WriteLog("WorkOrder->WoId", WoId);
        WriteLog("WorkOrder->token", user?.token );
        setPreViewLoading(true)
        await axios.get(process.env.REACT_APP_SERVER_BASE_URL +'/work_order/report/preview?id='+WoId,    
            {                
                headers: {                
                    'Authorization':user?.token,                    
                },
            }
            ).then(function (res){
                setPreViewLoading(false)
                    // console.log("PreviewReport->data", res.data);                      
                     var file = new Blob([base64ToArrayBuffer(res.data)], { type: 'application/pdf' });                    
                    // var fileURL = URL.createObjectURL(file);                    
                    // window.open(fileURL);                                       
                   saveFile(file);                                        
                }).catch(function(error){
                    setPreViewLoading(false)
                    WriteLog("PreviewReport->Error->", error);
            });
    }    
  return (
    <div className="flex-grow overflow-y-auto bg-white">
        <div className='pl-5 pt-5 text-2xl font-bold' >Active Work Orders:</div>
        <div className='flex ml-10 mt-5 items-baseline space-x-2'>
            <div className='text-xl font-bold'>Location:</div>
            <div className='text-sm'>{addrSeq>=0?location?.Name:"All"}</div>
        </div>    
    <div>    

    <div className='pl-10 pr-10'>
        <ThemeProvider theme={theme}>
            {!workorders &&
                <LinearProgress color='primary' />
            }
        </ThemeProvider>                
    </div> 
{/* <object 
style={{width: '100%', height: '200pt'}} 
type="application/pdf" 
data={'data:application/pdf;base64,'+byteArray}></object> */}
</div>

        <div className='pl-10 pt-1 pr-10'>
            {preViewLoading &&
                <LinearProgress animation="grow" size='sm' />
            }
        </div>                                    

        <div className='pl-10 pt-1 pr-10'>   
            <TableContainer component={Paper}>
                <Table>
                <colgroup>
                    <col width="10%" />
                    <col width="40%" />
                    <col width="20%" />
                    <col width="10%" />
                    <col width="15%" />                    
                </colgroup>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="left">Work Order #</StyledTableCell>
                            <StyledTableCell align="left">Description</StyledTableCell>
                            <StyledTableCell align="left">Schedule Date</StyledTableCell>
                            <StyledTableCell align="center">Status</StyledTableCell>
                            <StyledTableCell align="center">Tech.</StyledTableCell>
                            {/* <StyledTableCell align="center">Report</StyledTableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {workorders?.wo_history?.map((wo) => (              
                            <StyledTableRow key={`${wo.serv_order}`}>
                                <StyledTableCell align="center">                                    
                                    <div className="text-black font-bold rounded-full text-center bg-gray-300" style={{backgroundColor:wo.job_cat_color}}>{wo.serv_order}</div>                                    
                                </StyledTableCell>
                                <StyledTableCell align="left"><div className="text-gray-500 text-sm ml-2">{wo.wo_description}</div></StyledTableCell>                            
                                <StyledTableCell align="left">
                                    {wo.sched_date !== "" &&
                                        <div className="text-gray-600 text-sm">                                
                                            {
                                            new Intl.DateTimeFormat("en-GB", {
                                                year: "numeric",
                                                month: "long",
                                                day: "2-digit",
                                                hour: 'numeric', 
                                                minute: 'numeric',                                     
                                                hour12: true,
                                            }).format(convertUTCDateToLocalDate(new Date(wo.sched_date)))
                                            }                                                                
                                        </div>
                                        }
                                </StyledTableCell>                            
                                <StyledTableCell align="left">
                                    {wo.ins_prpt_release === 1 &&
                                        <div className='flex justify-evenly text-gray-400 cursor-pointer'>
                                            <div className='rounded-full p-1 hover:bg-gray-300'>
                                                <EyeIcon className='w-6 h-6 hover:text-gray-700' onClick={(e)=>PreviewReport(e, wo.serv_order)} />                                    
                                            </div> 
                                            <div className='rounded-full p-1 hover:bg-gray-300'>
                                                <ArrowDownTrayIcon className='w-6 h-6 hover:text-gray-700' onClick={(e)=>DownloadReport(e, wo.serv_order)} />
                                            </div>                                         
                                        </div>
                                    }
                                    {wo.ins_prpt_release === 0 &&
                                        <div className='bg-orange-400 text-white text-center rounded-lg p-0'>
                                            InProcess
                                        </div>
                                    }
                                    {/* <div className="text-sm bg-gray-200 text-orange-500  rounded-full text-center">{wo.is_complete==true?"Completed":"In Process"}</div> */}
                                    </StyledTableCell>       
                                <StyledTableCell align="left"><div className="text-sm text-gray-500 text-center">{wo.tech_name}</div></StyledTableCell>       
                                {/* <StyledTableCell align="center">
                                    <div className='flex justify-evenly cursor-pointer'>
                                       {preViewLoading ? 
                                            <Spinner animation="grow" size='sm' /> :
                                            <EyeIcon className='w-6 h-6 text-gray-400 hover:text-gray-400' onClick={(e)=>previewReport(e, appointment.work_order_id)}/>}
                                            {downloadLoading ?
                                            <Spinner animation="grow" size='sm' /> :
                                            <ArrowDownTrayIcon className='w-6 h-6 text-gray-400 hover:text-gray-700' onClick={(e)=>DownloadReport(e, appointment.work_order_id)} />
                                       }                                        
                                       <EnvelopeIcon className='w-6 h-6 text-gray-400 hover:text-gray-700' />
                                    </div>
                                </StyledTableCell>                      */}
                            </StyledTableRow>
                        ))}                          
                    </TableBody>
                </Table>
            </TableContainer>            
        </div>        
</div>
  )
}

export default WorkOrder